import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { fetchCommitmentData } from 'legacy/lut/services/partner360/commitment/fetchCommitmentData'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import MeasureController from 'core/analytics/MeasureController'
import { useMeasureController } from 'core/analytics/useMeasureController'

import styles from './CommitmentChangeDialog.module.scss'

const defaultMessageKey = 'jbp-commitment-drop-confirm'
const commitmentTypesParam = '[CommitmentTypes]'

interface IReplaceParams {
  key: string
  value: string
}

interface IChangeDialogProps {
  messageKey?: string

  onDiscard?: () => void
  onApply: () => void
  onCancel: () => void

  discardKey?: string
  applyKey?: string
  cancelKey?: string

  partnerId: string
  fyear: number
  programType: ProgramTypes

  metrics: MeasureController
}

export const CommitmentChangeDialog = ({
  messageKey = defaultMessageKey,
  onDiscard,
  onApply,
  onCancel,
  discardKey,
  applyKey,
  cancelKey,
  partnerId,
  fyear,
  programType,
  metrics,
}: IChangeDialogProps) => {
  const [replaceParams, setReplaceParams] = useState<IReplaceParams[]>()
  const [isLoaded, setIsLoaded] = useState(false)
  const { startLoadData, stopLoadData } = useMeasureController(metrics)
  const ownerId = useSelector(selectAppOwnerId)

  useEffect(() => {
    if (partnerId && fyear && programType) {
      startLoadData()
      fetchCommitmentData({
        ownerId,
        partnerId,
        fYear: fyear,
        programType,
      })
        .then((commitmentData) => {
          const acknowledgedBy = commitmentData
            .filter((el: ICommitmentData) => !!el.IsAcknowledged)
            .map((el: ICommitmentData) => el.CommitmentTypeName)

          const replaceParams = [
            {
              key: commitmentTypesParam,
              value: acknowledgedBy.join(', '),
            },
          ]
          setReplaceParams(replaceParams)
          setIsLoaded(true)
        })
        .finally(() => {
          stopLoadData()
        })
    }
  }, [ownerId, partnerId, fyear, programType, startLoadData, stopLoadData])

  return (
    <div className={styles.root}>
      {!isLoaded ? (
        <Loader />
      ) : (
        <>
          <Translation
            text={messageKey}
            span
            actionsInside
            replaceParams={replaceParams}
            htmlAvailable={true}
          />

          <footer className={styles.footer}>
            {onDiscard && (
              <Button className={styles.button} color="danger" onClick={onDiscard}>
                <Translation text={discardKey ?? 'jbp-discard'} />
              </Button>
            )}
            <Button className={styles.button} onClick={onApply}>
              <Translation text={applyKey ?? 'jbp-save'} />
            </Button>
            <Button className={styles.button} color="grey" onClick={onCancel}>
              <Translation text={cancelKey ?? 'jbp-cancel'} />
            </Button>
          </footer>
        </>
      )}
    </div>
  )
}
